
import { AES } from 'crypto-js';
import { secretApiKey } from '../params';

// Fonction pour chiffrer l'API key
export function encryptApiKey() {
  let result;
  try {
    const key = Date.now() + 60 * 1000; // La clé correspond à un timestamp valide 60s
    result = AES.encrypt(key.toString(), secretApiKey);
  }
  catch(err) {
    throw new Error("Error encrypt", err);
  }
  
  return result.toString();
}

